import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
    selector: 'app-revert-btn',
    templateUrl: './revert-btn.component.html',
    styleUrl: './revert-btn.component.scss',
    standalone: true,
    imports: []
})
export class RevertBtnComponent implements ICellRendererAngularComp {
  params: any;
  editBtnVisible: boolean = false;

  constructor(public sharedService: SharedService) {

  }

  agInit(params: any): void {
    this.params = params;

    if (
      params.data['reservation_id'] ||
      params.data['transferee_cert_signature'] ||
      params.data['driversId']
    ) {
      this.editBtnVisible = true;
    }
  }
  refresh(params?: any): boolean {
    // needed for the ICellRendererAngularComp
    return true;
  }

  // Button functions
  revertClick() {
    const rowData = {
      colValues: this.params.node.data,
      rowIndex: this.params.rowIndex,
    };
    this.params.revertItemClick(rowData);
  }
  selectClick() {
    const rowData = {
      colValues: this.params.node.data,
      rowIndex: this.params.rowIndex,
    };
    this.params.selectItemClick(rowData);
  }
}
